import React from "react";
import "../player-report-config/player-report-config.css";

export const MLB_TEAMS = [
  { id: 108, name: "Los Angeles Angels",       abbr: "LAA" },
  { id: 109, name: "Arizona Diamondbacks",     abbr: "ARI" },
  { id: 110, name: "Baltimore Orioles",        abbr: "BAL" },
  { id: 111, name: "Boston Red Sox",           abbr: "BOS" },
  { id: 112, name: "Chicago Cubs",             abbr: "CHC" },
  { id: 113, name: "Cincinnati Reds",          abbr: "CIN" },
  { id: 114, name: "Cleveland Guardians",      abbr: "CLE" },
  { id: 115, name: "Colorado Rockies",         abbr: "COL" },
  { id: 116, name: "Detroit Tigers",           abbr: "DET" },
  { id: 117, name: "Houston Astros",           abbr: "HOU" },
  { id: 118, name: "Kansas City Royals",       abbr: "KCR" },
  { id: 119, name: "Los Angeles Dodgers",      abbr: "LAD" },
  { id: 120, name: "Washington Nationals",     abbr: "WSH" },
  { id: 121, name: "New York Mets",            abbr: "NYM" },
  { id: 133, name: "Oakland Athletics",        abbr: "OAK" },
  { id: 134, name: "Pittsburgh Pirates",       abbr: "PIT" },
  { id: 135, name: "San Diego Padres",         abbr: "SDP" },
  { id: 136, name: "Seattle Mariners",         abbr: "SEA" },
  { id: 137, name: "San Francisco Giants",     abbr: "SFG" },
  { id: 138, name: "St. Louis Cardinals",      abbr: "STL" },
  { id: 139, name: "Tampa Bay Rays",           abbr: "TBR" },
  { id: 140, name: "Texas Rangers",            abbr: "TEX" },
  { id: 141, name: "Toronto Blue Jays",        abbr: "TOR" },
  { id: 142, name: "Minnesota Twins",          abbr: "MIN" },
  { id: 143, name: "Philadelphia Phillies",    abbr: "PHI" },
  { id: 144, name: "Atlanta Braves",           abbr: "ATL" },
  { id: 145, name: "Chicago White Sox",        abbr: "CWS" },
  { id: 146, name: "Miami Marlins",            abbr: "MIA" },
  { id: 147, name: "New York Yankees",         abbr: "NYY" },
  { id: 158, name: "Milwaukee Brewers",        abbr: "MIL" },
];

export const MLBTeamSelect = ({ selected, onSelect }) => (
  <select
    className="prc-year-select"
    value={selected?.id ?? ""}
    onChange={(e) => {
      const id = Number(e.target.value);
      onSelect(id ? MLB_TEAMS.find((t) => t.id === id) ?? null : null);
    }}
  >
    <option value="">Select a team…</option>
    {MLB_TEAMS.map((t) => (
      <option key={t.id} value={t.id}>{t.name}</option>
    ))}
  </select>
);
